const isDueDatePassed = (invoice, days = 0) => {
  const currentDate = new Date();
  const modifiedDueDate = new Date(invoice?.dueDate);
  modifiedDueDate.setDate(modifiedDueDate.getDate() + days);
  if (Object.prototype.hasOwnProperty.call(invoice, 'lateFeeApplies')) {
    if (invoice.lateFeeApplies === true) {
      return modifiedDueDate < currentDate;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

const customFilterAndSearch = (fieldToSearch, term) => {
  const searchTerm = term.toLowerCase();
  const fieldValue = fieldToSearch.toString().toLowerCase();

  return fieldValue.indexOf(searchTerm) !== -1;
};

const PAYMENT_STATUS_BUTTON_CONFIG = {
  paid: { text: 'Paid', className: 'btn paidBtn' },
  unpaid: { text: 'Unpaid', className: 'btn PendingBtn' },
  pending: { text: 'Pending', className: 'btn PendingBtn' },
  inqueue: { text: 'In Queue', className: 'btn PendingBtn' },
  failed: { text: 'Failed', className: 'btn DeclinedBtn' },
  declined: { text: 'Declined', className: 'btn DeclinedBtn' },
  visited: { text: 'Visited', className: 'btn PendingBtn' },
  yet_to_pay: { text: 'Yet to Pay', className: 'btn PendingBtn' },
  submitted: { text: 'Submitted', className: 'btn SubmittedBtn' },
  deleted: { text: 'Deleted', className: 'btn DeclinedBtn' },
  pastdue: { text: 'Past Due', className: 'btn PastDueBtn' },
  rejected: { text: 'Rejected', className: 'btn DeclinedBtn' },
  archived: { text: 'Archived', className: 'btn ArchivedBtn' },
};

export { isDueDatePassed, PAYMENT_STATUS_BUTTON_CONFIG, customFilterAndSearch };
